import {Injectable} from '@angular/core';
import {RouterStompService} from '~local/app/core/socket/RouterStompService';
import {WrappedCurrencyHistoryRate} from '../types/CurrencyHistoryRate';

@Injectable()
export class CurrencyRatesService {
  constructor(
    protected routerStompService: RouterStompService
  ) {}

  public getHistoryRates(ccyFrom: string, ccyTo: string, interval: string) {
    const topic = `/topic/${ccyFrom.toLowerCase()}${ccyTo.toLowerCase()}_${interval.toLowerCase()}`;
    return this.routerStompService.watch<WrappedCurrencyHistoryRate>(topic);
  }
}
